<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item active" aria-current="page">
      <a [routerLink]="'/promotion-tools/cms/content-library'">Content Library</a>
    </li>
    <li class="breadcrumb-item" aria-current="page">
      <span class="fs-5 fw-bold mb-0">Add Asset</span>
    </li>
  </ol>
</nav>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <div class="row g-3 mb-3">
        <div class="col">
          <label class="form-label">Name</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-tag"></i></span>
            <input type="text" class="form-control" placeholder="Name" formControlName="name">
          </div>
        </div>

        <div class="col">
          <label class="form-label">Type</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-file-earmark"></i></span>
            <select class="form-select" formControlName="type" (change)="onTypeChange()">
              <option value="" disabled>Select type</option>
              @for (type of assetTypes; track type) {
                <option [value]="type.identifier">{{ type.label }}</option>
              }
            </select>
          </div>
        </div>

        <div class="col">
          <label class="form-label">Product</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-box"></i></span>
            <select class="form-select" formControlName="productId">
              <option [ngValue]="null" disabled>Select product</option>
              @for (product of products; track product.id) {
                <option [ngValue]="product.id">{{ product.name }}</option>
              }
            </select>
          </div>
        </div>

        <div class="col">
          <label class="form-label">Language</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-translate"></i></span>
            <select class="form-select" formControlName="lang">
              <option [ngValue]="null">All languages</option>
              @for (language of languages; track language.isoCode) {
                <option [ngValue]="language.isoCode">{{ language.name }}</option>
              }
            </select>
          </div>
        </div>
      </div>

      @if (form.get('type')!.value) {
        <div class="mb-3">
          <label class="form-label">Content</label>
          @if (isTextType()) {
            <ul class="nav nav-tabs mb-3">
              <li class="nav-item">
                <button type="button" class="nav-link" [class.active]="inputMode === 'upload'"
                  (click)="inputMode = 'upload'">
                  <i class="bi bi-upload me-1"></i>Upload file
                </button>
              </li>
              <li class="nav-item">
                <button type="button" class="nav-link" [class.active]="inputMode === 'editor'"
                  (click)="inputMode = 'editor'">
                  <i class="bi bi-code-slash me-1"></i>Write content
                </button>
              </li>
            </ul>
          }
          @if (inputMode === 'upload') {
            <div>
              <div class="input-group">
                <span class="input-group-text"><i class="bi bi-file-earmark-arrow-up"></i></span>
                <input type="file" class="form-control" (change)="upload($event)">
              </div>
              @if (uploadFile) {
                <div class="form-text text-success">
                  <i class="bi bi-check-circle me-1"></i>{{ uploadFile.filename }}
                </div>
              }
            </div>
          }
          @if (inputMode === 'editor') {
            <div class="code-editor">
              <code-editor [(ngModel)]="editorContent" [ngModelOptions]="{standalone: true}" [extensions]="editorExtensions"/>
            </div>
          }
        </div>
      }

      <div class="row mt-4">
        <div class="col text-end">
          <button type="submit" class="btn btn-primary fw-bold">
            <span>Create</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
